<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid>
        <v-row
          align="center"
          justify="center">
          <v-col
            cols="12"
            sm="8"
            md="4">
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat>
                <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.user.activationForm') }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form @submit="submitActivation">
                  <v-text-field
                    v-model="formData.email"
                    label="Email"
                    type="email"
                    outlined
                    prependIcon="$vuetify.icons.user" />

                  <v-text-field
                    v-model="formData.new_password"
                    hideDetails
                    :label="$vuetify.lang.t('$vuetify.user.password')"
                    prependIcon="$vuetify.icons.lock"
                    type="password"
                    outlined />
                  <v-text-field
                    v-model="formData.new_password_confirmation"
                    hideDetails
                    :label="$vuetify.lang.t('$vuetify.user.passwordConfirm')"
                    prependIcon="$vuetify.icons.lock"
                    type="password"
                    outlined />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1" />

                <v-btn
                  color="primary"
                  :disabled="sending"
                  @click="submitActivation">
                  {{
                    $vuetify.lang.t('$vuetify.user.activation')
                  }}
                </v-btn>
                <div
                  v-if="sending"
                  class="d-flex align-center justify-center h-100">
                  <v-progress-circular
                    :size="25"
                    color="white"
                    indeterminate
                    :width="3" />
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      formData: {},
      sending: false,
    };
  },
  created() {
    const keyDown = event => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        this.submitActivation();
        window.removeEventListener('keydown', keyDown);
      }
    };
    window.addEventListener('keydown', keyDown);
  },
  methods: {
    ...mapActions('auth', { attemptLogin: 'attemptLogin' }),
    submitActivation() {
      this.sending = true;
      axios
        .put(`/user-activations/${this.$route.params.token}`, this.formData)
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('alerts/OPEN_SUCCESS', this.$vuetify.lang.t('$vuetify.messages.activationSuccess'));
            // eslint-disable-next-line
            const email = this.formData.email;
            const password = this.formData.new_password;
            this.attemptLogin({ email, password }).then(() => {
              this.$router.push({ name: 'processing' });
            });
          }
          this.sending = false;
        })
        .catch(error => {
          this.sending = false;
          if (error.response.status === 429) {
            this.$store.dispatch('alerts/OPEN_ERROR', this.$vuetify.lang.t('$vuetify.messages.APICallsNumberExceeded'));
          }
          if (error.response.data.errors) {
            this.$store.dispatch('alerts/OPEN_ERROR', error.response.data.errors[0].message, { root: true });
          } else {
            this.$store.dispatch('alerts/OPEN_ERROR', error.response.data.message, { root: true });
          }
        });
    },
  },
};
</script>
